<template>
	<div>
		<v-dialog
			v-model="showformdialog"
			hide-overlay
			transition="dialog-bottom-transition"
			fullscreen
		>
			<v-card>
				<div class="form-header d-inline-flex">
					<div class="">
						<v-btn icon dark @click="closeForm">
							<v-icon>chevron_left</v-icon>
						</v-btn>
					</div>
					<div class="d-flex align-center">
						{{ getStateWithParam("donation_form_header") }}
					</div>
				</div>

				<div class="form-area">
					<v-form ref="form" v-model="valid" class="form-color">
						<v-container>
							<v-text-field
								v-model="formdata.firstName"
								:rules="nameRules"
								:label="
									getStateWithParam('donation_form_firstname')
								"
								outlined
							></v-text-field>
							<v-text-field
								v-model="formdata.lastName"
								:rules="lastnameRules"
								:label="
									getStateWithParam('donation_form_lastname')
								"
								outlined
							></v-text-field>
							<v-text-field
								v-model="formdata.email"
								:rules="emailRules"
								:label="
									getStateWithParam('donation_form_email')
								"
								outlined
							></v-text-field>
							<v-text-field
								v-model="formdata.phoneNumber"
								:rules="numberRules"
								type="number"
								:label="
									getStateWithParam('donation_form_number')
								"
								outlined
							></v-text-field>
							<v-select
								v-model="donationName"
								:items="[donationName]"
								disabled
								:label="
									getStateWithParam(
										'donation_form_donationselect'
									)
								"
								required
								outlined="true"
							></v-select>

							<v-text-field
								v-model="formdata.topicIDs"
								:rules="subjectRules"
								:label="
									getStateWithParam('donation_form_subject')
								"
								outlined
							></v-text-field>

							<v-textarea
								v-model="formdata.message"
								:rules="messageRules"
								:label="
									getStateWithParam('donation_form_message')
								"
								outlined
								auto-grow
							></v-textarea>
						</v-container>
					</v-form>

					<div class="submit">
						<v-btn
							depressed
							class="submit-button align-center"
							@click.native="submitForm()"
						>
							{{
								getStateWithParam("donation_form_submit_button")
							}}
						</v-btn>
					</div>

					<v-dialog
						v-if="submitted && applicationError"
						v-model="submitted"
					>
						<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								{{
									getStateWithParam(
										"donation_form_toast_failed_title"
									)
								}}
							</v-card-title>

							<v-card-text>
								{{
									getStateWithParam(
										"donation_form_toast_failed_text"
									)
								}}
							</v-card-text>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									class="back-button"
									color="primary"
									text
									@click="goBack()"
								>
									{{
										getStateWithParam(
											"donation_form_toast_back_button"
										)
									}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<v-dialog
						v-if="submitted && !applicationError"
						v-model="submitted"
					>
						<v-card>
							<v-card-title class="text-h5 grey lighten-2">
								{{
									getStateWithParam(
										"donation_form_toast_success_title"
									)
								}}
							</v-card-title>

							<v-card-text>
								{{
									getStateWithParam(
										"donation_form_toast_success_text"
									)
								}}</v-card-text
							>

							<v-divider></v-divider>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn
									class="back-button"
									color="primary"
									text
									@click="goBack()"
								>
									{{
										getStateWithParam(
											"donation_form_toast_back_button"
										)
									}}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { DONATION_FORM_URL } from "@/config/api/url/urls_in_app";
import { API_CLIENT_POST_FORM } from "@/config/api/api_call/service_instances";
export default {
	name: "donationForm",
	components: {},
	props: {
		showformdialog: {
			type: Boolean,
			default: false,
		},

		donationId: {
			type: String,
			default: null,
		},

		donationName: {
			type: String,
			default: null,
		},

		donationSubjects: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			submitted: false,
			applicationError: false,
			formdata: {
				firstName: "",
				lastName: "",
				email: "",
				phoneNumber: "",
				donationId: "",
				topicIDs: "",
				message: "",
			},

			donationNameForm: "",

			valid: true,

			nameRules: [
				(v) => !!v || this.getStateWithParam("donation_form_name_rule"),
			],
			lastnameRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("donation_form_lastname_rule"),
			],
			numberRules: [
				(v) =>
					!!v || this.getStateWithParam("donation_form_number_rule"),
			],
			emailRules: [
				(v) =>
					!!v ||
					this.getStateWithParam("donation_form_required_email_rule"),
				(v) =>
					/.+@.+\..+/.test(v) ||
					this.getStateWithParam("donation_form_valid_email_rule"),
			],

			subjectRules: [
				(v) =>
					!!v || this.getStateWithParam("donation_form_subject_rule"),
			],

			messageRules: [
				(v) =>
					!!v || this.getStateWithParam("donation_form_message_rule"),
			],
		};
	},
	created() {},
	computed: {},
	watch: {
		showformdialog: function (val) {
			if (this.showformdialog) {
				this.formdata.donationId = this.donationId;
			} else {
				this.formdata.donationId = null;
			}
		},
	},
	methods: {
		goBack() {
			this.submitted = false;
			this.$router.back();
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		closeForm() {
			this.$router.back();
		},

		submitForm() {
			console.log(this.formdata);
			console.log(this.$refs.form.validate());
			if (this.$refs.form.validate()) {
				API_CLIENT_POST_FORM(DONATION_FORM_URL, this.formdata)
					.then((response) => {
						this.submitted = true;
						this.applicationError = false;
					})
					.catch((err) => {
						console.log(err);

						this.submitted = true;
						this.applicationError = true;
					});
			}
		},

		validateForm() {},
	},
};
</script>

<style scoped>
.form-header {
	width: 100%;
	background-color: #e60000;
	color: #ffffff;
	font-size: 20px;
}

.submit {
	display: flex;
	justify-content: flex-end; /* Align items to the end of the container */
	margin-top: 10px;
	margin-right: 6px;
}
.submit-button {
	background-color: #e60000 !important;
	color: #ffffff !important;
}

.form-color {
	color: aqua;
}

.back-button {
	color: #ffffff !important;
}
/* .details-close-btn {
	position: absolute;
	top: 0;
	left: 0;
} */
</style>
